import { darken, lighten, rgba } from 'polished';

export const createColorScaleSecondary = (
  color: string
): {
  10: string;
  50: string;
  100: string;
  200: string;
  300: string;
  400: string;
  500: string;
  600: string;
  700: string;
  800: string;
  900: string;
} => {
  return {
    10: rgba(color, 0.1),
    50: rgba(color, 0.1),
    100: rgba(color, 0.1),
    200: rgba(color, 0.1),
    300: rgba(color, 0.1),
    400: rgba(color, 0.1),
    500: rgba(color, 0.1),
    600: rgba(color, 0.2),
    700: rgba(color, 0.3),
    800: rgba(color, 0.1),
    900: rgba(color, 0.1),
  };
};
